/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_CreatingInputs */

const en_resumes_creating = /** @type {(inputs: Resumes_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating resume...`)
};

const de_resumes_creating = /** @type {(inputs: Resumes_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf wird erstellt...`)
};

const fr_resumes_creating = /** @type {(inputs: Resumes_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Création du CV...`)
};

const es_resumes_creating = /** @type {(inputs: Resumes_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando currículum...`)
};

const it_resumes_creating = /** @type {(inputs: Resumes_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creazione curriculum...`)
};

const nl_resumes_creating = /** @type {(inputs: Resumes_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV aanmaken...`)
};

const pl_resumes_creating = /** @type {(inputs: Resumes_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tworzenie CV...`)
};

const fi_resumes_creating = /** @type {(inputs: Resumes_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luodaan ansioluetteloa...`)
};

const da_resumes_creating = /** @type {(inputs: Resumes_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opretter CV...`)
};

const sv_resumes_creating = /** @type {(inputs: Resumes_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapar CV...`)
};

/**
* | output |
* | --- |
* | "Creating resume..." |
*
* @param {Resumes_CreatingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_creating = /** @type {((inputs?: Resumes_CreatingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_CreatingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_creating(inputs)
	if (locale === "fr") return fr_resumes_creating(inputs)
	if (locale === "es") return es_resumes_creating(inputs)
	if (locale === "it") return it_resumes_creating(inputs)
	if (locale === "nl") return nl_resumes_creating(inputs)
	if (locale === "pl") return pl_resumes_creating(inputs)
	if (locale === "fi") return fi_resumes_creating(inputs)
	if (locale === "da") return da_resumes_creating(inputs)
	if (locale === "sv") return sv_resumes_creating(inputs)
	return en_resumes_creating(inputs)
});